import { render } from "./mvt-snapshot.vue?vue&type=template&id=506ee7c6"
import script from "./mvt-snapshot.js?vue&type=script&lang=js"
export * from "./mvt-snapshot.js?vue&type=script&lang=js"

import "./mvt-snapshot.vue?vue&type=style&index=0&id=506ee7c6&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__